import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Paper,
    TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { StyleCreator } from "../../helpers/stylecreator";
import { useGetDataFromEverestQuery, useSwitchDealerGateWayToAdyenMutation } from "../../services/API/SwitchPaymentGatewayApiSlice";
import { FormStyleCollection as formStyles } from "../../styles/form";
import { formatPhoneNumber, isEmpty } from "../../utils/Util";

const SwitchToAdyenGateway = () => {
    const classes = StyleCreator.makeStyles(formStyles.all);

    //RTK Query hook to get gravity dealers list from the Everest.
    const {
        data,
        error,
        isError,
        isFetching
        } = useGetDataFromEverestQuery({ query: "PerseusPay.SearchGravityDealer", queryBody: "[]" }, {
            refetchOnMountOrArgChange: true,
        });
    
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [isProcessing, setIsProcessing] = useState(true);
    const [DealersList, SetDealersList] = useState<any>([]);
    
    useEffect(() => {
        if (data) {
            if (data.length === 0 && !isFetching) toast.warning("No more Dealers are using Gravity Payment Gateway"); 
            SetDealersList(data);
            setIsProcessing(false);
        }
    }, [data, error, isError]);

    //RTK Mutation hook to change the dealer gateway from gravity to adyen.
    const [InitiateTheGatewaySwitch, {isError: IsSwitchError, error: SwitchError}] = useSwitchDealerGateWayToAdyenMutation();

    const refreshList = () => {
        setIsProcessing(false);
        setSelectedDealer(null);
    }

    const handleSubmit = async () => {
        if (!selectedDealer) return;
        try {
            setIsProcessing(true);
            const response = await InitiateTheGatewaySwitch(selectedDealer.DealerId).unwrap();
            response
                ? toast.success("Payment Gateway successfully changed to Adyen for this dealer")
                : toast.error("unable to change the gatway, please try again later");
        }
        catch (err) {
            if (err && err['status'] === 404) toast.error("dealer not found");
            else toast.error("An error occurred while switching the gateway.",err);
        }
        finally {
            refreshList();
        }
    };

    const GetDealerAddressInfo = ({ City, StateOrProvince }: any): string => 
    [City, StateOrProvince].filter((val) => !isEmpty(val)).join(", ");

    const GetDealerContactInfo = ({ Phone, Email, ...row }: any): string => 
        [Email, formatPhoneNumber(Phone, row)].filter((val) => !isEmpty(val)).join(", ");

    return (
    <Box display="flex" justifyContent="center" alignItems="center">
        <Paper>
        <Box
            style={{
            padding: "5px",
            fontSize: "18px",
            color: "#3366ff",
            borderBottom: "1px solid #EAEDED",
            marginBottom: "20px",
            }}
        >
            Change Payment Gateway
        </Box>
        <Box style={{
            margin: "20px 5px 0px 15px",
            border: "0px solid red",
            fontSize: "small"
            }}
        >
            <Autocomplete
            id="combo-box-demo"
            autoHighlight
            options={DealersList}
            value={selectedDealer}
            getOptionLabel={(option: any) => {
                    let label = `${option.Name} - ${option.DmsDealerId}`;
                    return label;
                }}
            renderOption={(
                props: any,
                option: any,
            ) => (
                <li
                {...props}
                style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    fontSize: "small",
                }}
                >
                {option.Name} ({option.DmsDealerId} -{" "}
                {option.DmsName})
                <br />
                {GetDealerAddressInfo(option)}
                <br />
                {GetDealerContactInfo(option)}
                </li>
            )}
            style={{
                width: 565,
                marginTop: "10px",
            }}
            className={classes.autoComplete}
            fullWidth
            onChange={(event, value) => setSelectedDealer(value || null)}
            renderInput={(params) => (
                <TextField
                size="small"
                variant="standard"
                sx={{ fontSize: "small" }}
                {...params}
                label="Search by Name or Number"
                style={{ padding: "0px" }}
                fullWidth
                />
            )}
            />
            {(
                <span style={{ color: "gray", float: "right", textAlign: "right" }}>
                    This will only show the gravity dealers who are pre-onboarded.
                </span>
            )}
        </Box>       

        <Box
            style={{
                padding: "10px 10px 10px 10px",
                textAlign: "left",
                marginTop: "30px",
        }}>
            <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                disabled={!selectedDealer || isProcessing}
                >
                {isProcessing ? <CircularProgress size={24} /> : "Switch to Adyen"}
            </Button>
        </Box>

        </Paper>
    </Box>
    );
    };

export default SwitchToAdyenGateway;
